import classNames from 'classnames';

import { FCC } from '../../../utils/types';
import './card.scss';

interface Props {
  color?: 'blue' | 'gray-dark' | 'purple-10';
  className?: string;
  noMargin?: boolean;
}

const Card: FCC<Props> = ({ children, color = '', className = '', noMargin }) => (
  <div className={classNames('card', color, className, { 'no-margin': noMargin })}>{children}</div>
);

export default Card;
